import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular/standalone';

import { DemoozCookiesService } from '@demooz/services';
import { LanguageGuard } from '@app/guards'
import { DataService, AmbassadorService, NotificationService } from '@app/services';
import { Ambassador } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    
    constructor(
        private navController: NavController,
        private demoozCookiesService: DemoozCookiesService,
        private languageGuard: LanguageGuard,
        private dataService: DataService,
        private ambassadorService: AmbassadorService,
        private notificationService: NotificationService
    ) { }
    
    async checkTokenLogin(redirectLogin: boolean = true) {    
        let check: boolean = false;
        if(this.dataService.ambassador.value){
            check = true;
        }
        else if(this.demoozCookiesService.get('auth', false)){
            let ambassador = await this.ambassadorService.fetchAmbassador();
            if(ambassador){
                this.dataService.ambassador = new Ambassador(ambassador);
                this.dataService.resetOperation();
                check = true;
            }
        }     
        
        if(!check){
            await this.logout(redirectLogin);
        }
           
        return check;
    }
    
    async logout(redirectLogin: boolean = true){
        
        this.dataService.resetLogout();
        this.notificationService.isInitialized = false;
        this.demoozCookiesService.delete('auth', false);
                
        if(redirectLogin){
            await this.languageGuard.initLanguages();
            this.navController.navigateRoot('login', {replaceUrl: true});
        }
    }
}
